import { ReactElement, useCallback } from 'react';

import { TutorsResponse } from '../types';
import { getStudentTutors } from '../../../api/studentTutorsRequests';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../components/Info/DisplayError';
import Loading from '../../../../../../components/Info/Loading';

export interface TutorsLoaderProps<T> {
  studentId: string | number;
  children: (props: { data: T; refresh: Function }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  {
    studentId: number | string;
  },
  TutorsResponse
>();

export const TutorsLoaderConsumer = FetchConsumer;

export function TutorsLoader({
  studentId,
  children,
}: TutorsLoaderProps<TutorsResponse>) {
  const request = useCallback(() => {
    return getStudentTutors(studentId);
  }, [studentId]);
  return (
    <FetchProvider
      request={request}
      defaultQuery={{ studentId }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
